<template>
    <b-container fluid class="p-0 no-gutters h-100">
        <b-row class="p-0 no-gutters h-100 w-100">
            <b-input-group size="lg" class="w-100">
                
                <b-col v-if="$scopedSlots.start" cols="3" class="py-1">
                    <slot name="start" :pins="listPins.pins"/>
                </b-col>
                <!--Gestion des filtres de périmètres -->
                <b-col v-if="!Grouping" sm="auto" aligh-h="start" cols="2" class="p-0 h-100 d-flex align-items-center"><!-- v-else -->
                    <b-input-group-prepend>
                        <!-- Gestion de la liste de périmètres -->
                        <portal to="NavbarPortal" >
                            <!-- Bouton pour Gérer la liste de périmètres -->
                             <!-- $t('ScopeManagement') / Gestion des périmètres -->
                             <!-- $t('Filtres') / Gestion des périmètres -->
                                <b-dropdown v-b-tooltip.noninteractive.hover.topright :title="$t('ScopeManagement')" :disabled="Disable" :variant="'outline-' + Variant" :text="$t('Filters')" size="sm" no-caret
                                    ref="dropdown" toggle-class="btn-circle border-0" menu-class="p-0 enlarge" class="mx-0" style="z-index: 1001;">
                                    <template #button-content>
                                        <b-icon v-if="filter()?.Name" icon="funnel-fill" />
                                        <b-icon v-else icon="funnel" />
                                    </template>
                                    <!-- $t('RecentScopes') / Périmètres récents -->
                                    <b-dropdown-header class="font-weight-bold">{{ $t('RecentScopes') }}</b-dropdown-header>
                                    <!-- Liste des périmètres récents -->
                                    <b-dropdown-item v-for="filter in lastFilters()" :key="filter.Id" 
                                        @click="loadFilter(filter.Id)">
                                        <b-row>
                                            <b-col class="align-self-center text-truncate" v-b-tooltip.noninteractive.hover :title="filter.Label">{{ filter.Label }}</b-col>
                                        </b-row>
                                    </b-dropdown-item>
                                    <!-- Bouton pour voir tous les périmètres enregistrés (Modal Périmètres enregistrés) -->
                                    <b-dropdown-form class="p-0 text-center">
                                        <!-- $t('SeeAllRegisteredScope') / Voir tous les périmètres enregistrés -->
                                        <b-button @click="savedFiltersVisible = true" :variant="'outline-' + Variant" pill class="font-weight-bold">{{ $t('SeeAllRegisteredScope') }}</b-button>
                                    </b-dropdown-form>
                                    <SavedFilters v-if="savedFiltersVisible" v-model="savedFiltersVisible" :FilterTreeStore="FilterTreeStore" @DeleteFilterEvent="deleteFilter" />
                                </b-dropdown>
                        
                                <!-- Nom du filtre chargé -->
                                <span v-if="filter()?.Name" class="text-black font-weight-bold text-truncate d-inline-block align-middle" style="max-width: 20rem !important;"  v-b-tooltip.noninteractive.hover :title="filter()?.Name">{{ filter()?.Name }}</span>
                                <!-- $t('NoSavedScopeApplied') / Aucun périmètre enregistré appliqué -->
                                <span v-else class="text-gray-dark">{{ $t('NoSavedScopeApplied') }}</span>                                
                                <span class="border-left border border-muted ml-2" />
                                <!-- Bouton pour réinitialiser le filtre -->
                                <!-- $t('Reset') / Réinitialiser -->
                                <b-link v-if="Number(filter()?.Id) > 0" @click="$store.dispatch(FilterTreeStore + '/LoadFilter', { filter: filter() })" class="p-2" :class="'text-' + Variant">{{ $t('Reset') }}</b-link>
                                <!-- Bouton pour Enlever le filtre -->
                                <!-- $t('TakeOff') / Enlever -->
                                <b-link v-if="Number(filter()?.Id) > 0" @click="removeFilter();" class="p-2 text-danger">{{ $t('TakeOff') }}</b-link>
                        </portal>
                    </b-input-group-prepend>
                </b-col>

                <!-- Rendu des pins -->
                <b-col class="p-0 no-gutters align-items-center">
                    
                    <b-form-tags :id="$id('GlobalFilter')" :input-id="$id('GlobalFilter')" :ref="$id('GlobalFilter')"  v-model="listPins.pins" no-add-on-enter no-outer-focus
                        class="position-absolute overflow-hidden border-0 bg-white py-1" :style="filtersBarOpened ? 'z-index: 2000;' : 'z-index: 0;'">
                        <template v-slot="{ tags, removeTag }">
                            <b-overlay :show="Disabled" :opacity="0.2" variant="gray-light" >
                                <template #overlay>
                                    <div class="m-0 pt-1 h-100 text-center d-flex align-items-center justify-content-center"/>
                                </template>
                                <ul id="my-custom-tags-list"
                                    class="list-unstyled d-inline-flex flex-wrap"
                                    aria-live="polite"
                                    aria-atomic="false"
                                    aria-relevant="all">
                                    <!-- Liste les pins (étiquettes) dans pins pour les ajouter dans la barre de filtre -->
                                    <b-button v-for="tag in tags" :key="tag"
                                        :id="`my-custom-tags-tag_${tag.replace(/\s/g, '_')}_`"
                                        size="sm" pill tag="li"
                                        :variant="'outline-' + (JSON.parse(tag).Included ? Variant : 'gray-dark')" 
                                        :class="'bg-' + (JSON.parse(tag).Included ? Variant : 'gray-dark') + '-bg-subtle'"
                                        class="p-1 mb-2 mx-1"
                                        @click="$store.dispatch(FilterTreeStore + '/SetPropertiesFilterVisible', true); selectedPin = JSON.parse(tag)">

                                        <!-- b-tooltip au lieu du v-b-tooltip pour affichage conditionnel uniquement sur les Pins de propriété -->
                                        <b-tooltip :target="`my-custom-tags-tag_${tag.replace(/\s/g, '_')}_`" triggers="hover" :disabled="!(JSON.parse(tag).Type===pinTypeEnum.None)">
                                            {{ JSON.parse(tag).Text }}
                                        </b-tooltip>

                                        <!-- Bouton pour basculer entre Inclus (signe +) / Exclus (signe -) -->
                                        <b-icon @click.stop="toggleIncluded(JSON.parse(tag));" 
                                            :icon="JSON.parse(tag).Included ? 'plus' : 'dash'"  
                                            :class="'border-' + (JSON.parse(tag).Included ? Variant : 'gray-dark')" 
                                            class="mx-1 border rounded-circle" :aria-controls="`my-custom-tags-tag_${tag.replace(/\s/g, '_')}_`" />

                                        <!-- Mise en forme pour le type de tag par Propriété -->
                                        <template v-if="JSON.parse(tag).Type===pinTypeEnum.None">
                                            <b-icon icon="tags" class="py-0" />
                                            <span class="d-inline-flex text-truncate" :style="{'max-width': '7rem'}" > {{JSON.parse(tag).Text}}</span>
                                        </template>

                                        <!-- Mise en forme pour le type de tag issu de l'Arborescence -->
                                        <template v-else-if="JSON.parse(tag).Type===pinTypeEnum.Tree">
                                            <b-icon icon="ui-checks" class="py-0" />
                                            <span> {{JSON.parse(tag).Text}}</span>
                                        </template>

                                        <!-- Texte par défaut -->
                                        <span v-else> {{JSON.parse(tag).Text}}</span>

                                        <!-- Bouton pour supprimer le tag -->
                                        <b-icon @click="removePin(JSON.parse(tag));removeTag(tag);" icon="x" class="p-0 ml-2 text-danger" role="button" />
                                    </b-button>
                                </ul>
                            </b-overlay>
                        </template>
                    </b-form-tags>

                </b-col>

                <b-col cols="2" align-h="end" class="p-0 mx-2 col-sm-auto no-gutters d-flex align-items-center">
                    <b-input-group-append class="float-right">
                        <!-- Bouton pour étendre la hauteur de la barre de filtre -->
                        <!-- $t('ExtendFilterBar') / Étendre la barre de filtres -->
                        <b-button v-if="isOverflowing" @click="toggleAutoHeightFiltersBar()" v-b-tooltip.noninteractive.hover :title="$t('ExtendFilterBar')" variant="outline-dark"
                            class="btn-circle p-0 mt-1 mr-1 border-0">
                            <b-icon v-if="filtersBarOpened" icon="chevron-up" />
                            <b-icon v-else icon="chevron-down" />
                        </b-button>
                            
                        <!-- Bouton d'enregistrement du filtre -->
                        <!-- $t('SaveA') / Enregistrer un -->
                        <!-- (Grouping ? Grouping : Perimeter) -> (Grouping ? 'regroupement' : 'périmètre') -->
                        <b-button v-if="ShowSave" @click="saveFilterVisible = true" :disabled="listPins.pins.length == 0" v-b-tooltip.noninteractive.hover :title="$t('SaveA') + ' ' + (Grouping ? $t('Grouping')  : $t('Perimeter') )" variant="outline-dark" class="btn-circle border-0 m-1">
                            <i class="bi bi-floppy" />
                        </b-button>
                        <SaveFilter v-if="saveFilterVisible" v-model="saveFilterVisible" :FilterTreeStore="FilterTreeStore" :IsGrouping="Grouping" :KeepAncestors.sync="keepAncestors" />
                    </b-input-group-append>
                </b-col>
            </b-input-group>
        </b-row>
        
        <!-- Filtres par propriété de type objet -->
        <PropertiesFilter v-if="propertiesFilterVisible == true" v-model="propertiesFilterVisible" :FilterTreeStore="FilterTreeStore" :Pin.sync="selectedPin" :PropertiesFilterPinTypes="PropertiesFilterPinTypes" />
    </b-container>
</template>
<script lang="ts">
    import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';
    import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
    import locales from './locales/Pins.json'
    import BasePins from './Pins/BasePins';
    import FilterT from '@/types/FilterTree/FilterT';
    import PinTypeEnum from '@/enums/PinTypeEnum';

    /** Fenêtres modales par types de filtres */
    import SavedFilters from './Pins/SavedFilters.vue';
    import PropertiesFilter from './Pins/PropertiesFilter.vue';
    import SaveFilter from './Pins/SaveFilter.vue';
    import Pin from '@/types/FilterTree/Pin';

    /** Composant de gestion des filtres */
    @Component({
        components: {
            FontAwesomeIcon,
            /** Fenêtres modales par types de filtres */
            SavedFilters,
            PropertiesFilter,
            SaveFilter
        },
        i18n: {messages: locales}
    })
    export default class Pins extends BasePins {
        /** Gestion des regroupements ou non */
        @Prop()
        public Grouping!: boolean;

        /** Permet l'affchage du bouton save */
        @Prop({ default: true })
        public ShowSave!:boolean;

        /** Permet de désactiver le module Pin */
        @Prop({ default: false })
        public Disabled!: boolean;

        /** Indication de conservation des ancetres */
        @PropSync('KeepAncestors', {default : false})
        public keepAncestors!: boolean;

        /** Nécessaire pour pouvoir utiliser l'enum PinTypeEnum dans la section template */
        private pinTypeEnum = PinTypeEnum;

        /** Liste des pins locale pour pouvoir utiliser le b-form-tags */
        private listPins: { pins: Pin[] } = { pins: [] };

        //#region v-model d'affichage des modal pour chaque type de filtre
        private savedFiltersVisible: boolean = false;
        private saveFilterVisible: boolean = false;
        //#endregion v-model d'affichage des modal pour chaque type de filtre

        //#region Gestion de l'overflow de la barre de tags
        private autoHeightFiltersBar: boolean = false;
    
        /** Indique si la liste des tags dépasse l'emplacement en hauteur du b-form-tags ou non */
        private isOverflowing: boolean = false;
    
        private prevScrollHeight: number = 0;
        private initScrollHeight: number = 0;
    
        /** Barre de filtres ouverte ou non */
        private filtersBarOpened: boolean = false;
        //#endregion Gestion de l'overflow de la barre de tags

        private loadGrouping(id: number) {
            let filter: FilterT = { Id: id.toString(), Name: "", Remark: "", Color: "", Pins: [] } as FilterT;
            this.$store.dispatch(this.FilterTreeStore + "/LoadGrouping", { filter: filter });
        }

        /**
         * Vérifie si la hauteur de la barre de filtres est inférieure à la hauteur des pins qu'elle peut contenir en hauteur
         * Met à jour la propriété isOverflowing en conséquence
         * */
        private checkHeightOverflowing() {
            console.debug("Pins - checkHeightOverflowing() - uid : %i-GlobalFilter", this.uid);
            var element = document.getElementById(this.uid + '-GlobalFilter'); // (this.$refs.GlobalFilter as HTMLElement);
            if (element === null) return;

            var newOverflow = (element.offsetHeight < element.scrollHeight); //|| element.offsetWidth < element.scrollWidth;

            console.debug("Pins - checkHeightOverflowing() - this.prevOffsetHeight : %f - element.offsetHeight : %f < element.scrollHeight : %f = this.newOverflow : %f", this.prevScrollHeight, element.offsetHeight, element.scrollHeight, newOverflow);
            console.debug("Pins - checkHeightOverflowing() - this.isOverflowing : %s - newOverflow : %f - this.initScrollHeight : %f", this.isOverflowing, newOverflow, this.initScrollHeight);
            // Si l'état précédent et le nouvel état sont différent. Et qu'il n'y a pas plus d'overflow
            if ((this.isOverflowing != newOverflow)
                && !newOverflow
                && (element.scrollHeight != this.prevScrollHeight)
                && (element.scrollHeight === this.initScrollHeight)) {
                // TODO : gérer cela via la méthode toggleAutoHeightFiltersBar() + à gérer avec un @Watch('this.isOverflowing')
                element.classList.remove("h-auto");
                this.autoHeightFiltersBar = false;
                console.debug("Pins - checkHeightOverflowing() - element.classList.remove('h-auto');");
            }

            console.debug("Pins - checkHeightOverflowing() - element.scrollHeight : %f != this.prevScrollHeight : %f - element.scrollHeight : %f === this.initScrollHeight : " + this.initScrollHeight, element.scrollHeight, this.prevScrollHeight, element.scrollHeight);
            if ((element.scrollHeight != this.prevScrollHeight)
                && ((element.scrollHeight === this.initScrollHeight) && this.isOverflowing)
                || ((element.scrollHeight != this.initScrollHeight) && !this.isOverflowing)) {
                this.isOverflowing = newOverflow;
            }

            this.prevScrollHeight = element.scrollHeight;

            console.debug("Pins - checkHeightOverflowing() - element.offsetHeight : %f < element.scrollHeight : %f - this.isOverflowing : %f", element.offsetHeight, element.scrollHeight, this.isOverflowing);
        }

        private toggleAutoHeightFiltersBar() {

            this.autoHeightFiltersBar = !this.autoHeightFiltersBar;

            var element = document.getElementById(this.uid + '-GlobalFilter');

            if (element === null) return;

            if (this.autoHeightFiltersBar)
                element.classList.add("h-auto");
            else
                element.classList.remove("h-auto");

            this.prevScrollHeight = element.scrollHeight;

            this.filtersBarOpened = !this.filtersBarOpened;
        }

        /** 
         * Pointeur vers fonction pour désactiver watchers
         * @see https://vuejs.org/guide/essentials/watchers#stopping-a-watcher
         **/
        private unwatchGetPins = undefined;

        /** La hauteur de la barre de filtres est redimenssionnée à chaque mise à jour de liste de Pins ou bien sur redimenssionement de la fenêtre */
        async created() {
            this.unwatchGetPins = this.$store.watch((state, getters) => getters[this.FilterTreeStore + '/GetPins'], val => {
                console.debug('Pins - created() - watch - this.FilterTreeStore : %O - val : %O - this.FilterPins : %O', this.FilterTreeStore, val, this.FilterPins)
                if(this.FilterPins)
                    this.listPins.pins = val.filter(this.FilterPins);
                else
                    this.listPins.pins = val;

                this.checkHeightOverflowing();
            }, { deep: true, immediate: true })

            Vue.nextTick(() => {
                // Permet le check si la hauteur de la b-form-tags dépasse la hauteur des pins empilés ou non lorsque la fenêtre du navigateur est redimensionnée
                window.addEventListener('resize', this.checkHeightOverflowing);
            });

            /** Chargement de la liste des filtres existants sur le server */
            await this.$store.dispatch(this.FilterTreeStore + "/LoadFilters");
        }

        mounted() {
            var element = document.getElementById(this.uid + '-GlobalFilter');

            // Retire la classe par défaut h-auto sur l'élément b-form_tags au chargement qui empêche de définir une hauteur sur cet élément
            if (element !== null)
                element.classList.remove("h-auto");

            var element = document.getElementById(this.uid + '-GlobalFilter'); // (this.$refs.GlobalFilter as HTMLElement);
            if (element === null) return;
            this.initScrollHeight = element.scrollHeight;

            console.debug("Pins - mounted() - element.offsetHeight : %f", element.offsetHeight);
        }

        updated() {
            console.debug("Pins - updated()");
            // Test si overflow de la liste de pins après que le rendu du DOM soit mis à jour
            this.checkHeightOverflowing();

            //var element = document.getElementById(this.uid + '-GlobalFilter'); // (this.$refs.GlobalFilter as HTMLElement);
            //if (element === null) return;
        }

        beforeDestroy() {
            console.debug("Pins - beforeDestroy()");
            window.removeEventListener('resize', this.checkHeightOverflowing);

            // Libération du watcher
            if (this.unwatchGetPins)
                this.unwatchGetPins();
        }
    }
</script>
<style scoped>
    /** Pour élargir la dropdown contenant la liste des filtres chargeables */
    :deep(.dropdown-menu.show.enlarge) {
        min-width: 20rem !important;
        max-width: 20rem !important;
    }   

    /** Pour afficher une couleur de fond sur les items de la dropdown
        @todo Faire en sorte que le secondary soit utilise plutôt le Variant dynamiquement
    */
    :deep(.dropdown-item:hover) {
        background-color: var(--secondary-bg-subtle) !important;
    }
</style>
